export class ReasonRequest {
  id: number;
  name: string;
  idExternal: number;
}
